import { createGlobalStyle } from "../Themes";

export default createGlobalStyle`
    .pac-container {
        z-index: 1020000;
    }
`;
